document.querySelectorAll( '.b-list-modal' ).forEach( ( block ) => {

    /////////////////////
    // BLOCK CODE HERE //
    /////////////////////

} );
    